module.exports = __webpack_public_path__ + "img/attendance_record.bc19038a.svg";